"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CURIE_SEPARATOR = exports.supportedProcessors = exports.supportedPostProcessors = exports.supportedContentTypes = exports.defaultConfigurations = exports.supportedEnvironments = void 0;
exports.supportedEnvironments = {
    stereotypeServiceIntegrationUrl: 'https://stereotype.staging.trdlnk.cimpress.io',
    stereotypeServiceProductionUrl: 'https://stereotype.trdlnk.cimpress.io'
};
exports.defaultConfigurations = {
    baseUrl: exports.supportedEnvironments.stereotypeServiceProductionUrl,
    timeout: 5000,
    numRetries: 3
};
exports.supportedContentTypes = {
    handlebars: ['text/handlebars', 'text/x-handlebars-template'],
    edie: ['application/vnd.cimpress.edie+json']
};
exports.supportedPostProcessors = [
    'mjml',
    'xlsx'
];
exports.supportedProcessors = [
    'edie',
    'handlebars',
    'mjml',
    'mime',
    'dust',
    'ediecsv',
    'htmlpdf',
    'xlsx'
];
exports.CURIE_SEPARATOR = ';';
